import React from "react"
import WOW from "react-wow"

import * as S from "./styled"

const PortfolioItem = ({ category, title, img, slug }) => {
  return (
    <S.PortfolioItemWrapper to={slug}>
      <S.PortfolioItemContent>
        {img && img.childImageSharp ? (
          <S.PortfolioItemBGFluid fluid={img.childImageSharp.fluid}>
            <div className="overlay"></div>
          </S.PortfolioItemBGFluid>
        ) : (
          <S.PortfolioItemBG img={img && img.publicURL} effect="blur">
            <div className="overlay"></div>
          </S.PortfolioItemBG>
        )}
        <WOW animation="fadeInUp">
          <S.PortfolioItemCategory>{category}</S.PortfolioItemCategory>
          <S.PortfolioItemTitle>{title}</S.PortfolioItemTitle>
        </WOW>
      </S.PortfolioItemContent>
    </S.PortfolioItemWrapper>
  )
}

export default PortfolioItem
